// extracted by mini-css-extract-plugin
module.exports = {"titleMain":"Title_titleMain__16Fi4"};